/**
 * Login Attempt Model.
 */
export interface ILoginAttemptModel {
  /** IP Address of the login attempt.  */
  ipAddress: string;
  /** Email from the login attempt payload. */
  email: string | null;
  /** API Key or JWT used for authentication. */
  authToken: string | null;
  /** Time of the login attempt. */
  attemptTime: Date;
}
